
module.exports = function() {
  return {
        restrict: 'EA',
        replace: true,
        template: require('raw!shared/footer.html'),
        controller: FooterController,
        controllerAs: 'ftrCtrl'
    }
};
function FooterController(contentful, $scope, $state, $stateParams, store, $sce) {
  contentful.entries("content_type=footer&include=3").then(function(res) {
    $scope.footer = res.data.items[0];
    // console.log('footer', res);
  })

}



/** WEBPACK FOOTER **
 ** ./components/shared/footer.js
 **/